import { useState } from "react";

import { MenuIcon, XCircleIcon } from "@heroicons/react/solid";

const Nav = () => {
    const [showMenu, setShowMenu] = useState(false);

    const showMenuHandler = () => setShowMenu((state) => !state);

    const detailsLinks = [
        { id: 0, title: "صفحه اصلی", href: "/" },
        { id: 1, title: "درباره کتابخانه", href: "/" },
        { id: 2, title: "جستجوی منابع", href: "/" },
        { id: 3, title: "خدمات عمومی", href: "/" },
        { id: 4, title: "خدمات آموزشی و پژوهشی", href: "/" },
        { id: 5, title: "اخبار و اطلاعیه ها", href: "/" },
        { id: 6, title: "ارتباط با کتابخانه", href: "/" },
    ];

    const linkElemets = detailsLinks.map((link) => (
        <li className="p-1 my-1 hover:text-sky-400 text-center lg:mx-2 lg:text-[14px] xl:text-base" key={link.id}>
            <a href="/" className=" block">{link.title}</a>
        </li>
    ));

    return (
        <>
            <button className="xl:hidden" onClick={showMenuHandler}>
                {showMenu ? <XCircleIcon className=" w-8 " /> : <MenuIcon className=" w-8 " />}
            </button>
            <nav>
                <ul
                    className={`${showMenu ? "flex" : "hidden"} 
                    flex-col menu absolute bg-slate-200 text-sky-700 w-[98%] top-full right-2 rounded-lg 
                    xl:static xl:flex xl:flex-row xl:bg-transparent xl:text-slate-50 xl:w-auto`}
                >
                    {linkElemets}
                </ul>
            </nav>
        </>
    );
};

export default Nav;
